<template>
    <Loading>
        <div class="d-flex flex-column pa-2 justify-content-center align-items-center">
            <Row class="image-row" />
            <Row />
        </div>
    </Loading>
</template>

<script>
import Loading from './base/Loading';
import Row from './base/Row';

export default {
    name: 'ImageTextSkeleton',
    components: { Loading, Row },
};
</script>

<style scoped>
.image-row {
    height: 120px !important;
}
</style>
